import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]

  update(event) {
    if (!this.hasOutputTarget) return

    const html = event.target.value
    if (html.trim() === "") {
      this.outputTarget.innerHTML = '<span class="text-muted">No content to preview</span>'
    } else {
      this.outputTarget.innerHTML = html
    }
  }
}
